import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "align-start justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("TicketScan")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Сканирование билетов")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { id: "firebaseui-auth-container" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createVNode(_component_v_card_title, null, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }),
    _createVNode(_component_v_card_subtitle, null, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }),
    _hoisted_8
  ]))
}